import { koComponent } from '../ko-utils';

class StdConfirmBody {
    constructor(params) {
        this.text = params.text;

        this.buttonSet = params.buttonSet || 'delete';

        this.checkQuestion = params.checkQuestion;
        this.checkAnswer = params.checkAnswer;

        this.typedCheckAnswer = ko.observable();

        this.successCallback = params.success;
        this.cancelCallback = params.cancel;

        this.isSubmitting = ko.observable(false);

        this.shouldBeEnabled = ko.computed(() => {
            if (this.isSubmitting()) return false;

            return !ko.unwrap(this.checkQuestion) || ko.unwrap(this.checkAnswer) == ko.unwrap(this.typedCheckAnswer);
        });

        this.mainButtonTypesMap = {
            'delete': { class: 'btn-danger', text: 'Delete' },
            'yes': { class: 'btn-success', text: 'Yes' },
        }

        this.mainButtonClass = ko.pureComputed(() => {
            return this.mainButtonTypesMap[this.buttonSet].class;
        });

        this.mainButtonText = ko.pureComputed(() => {
            return this.mainButtonTypesMap[this.buttonSet].text;
        });
    }

    success() {
        this.isSubmitting(true);

        this.successCallback();
    }

    cancel() {
        this.cancelCallback();
    }
}

export default koComponent('std-confirm-body', StdConfirmBody);